import { useEffect, useState } from "react";
import { useI18n, type StringKey } from "../i18n";
import { loadTeam, type TeamMember } from "../data";

const tone: Record<TeamMember["today"], string> = { present: "success", late: "warning", on_leave: "info", absent: "danger", day_off: "neutral" };

/** A manager's people, with where they are today. */
export function Team({ onOpen }: { onOpen: (employmentId: string) => void }) {
  const { t, pick } = useI18n();
  const [rows, setRows] = useState<TeamMember[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => { loadTeam().then(setRows).catch((e) => setError(e.message)); }, []);

  return (
    <div className="page">
      {error && <p className="alert danger" role="alert">{error}</p>}
      {rows === null ? <p className="muted">{t("loading")}</p> : rows.length === 0 ? <p className="muted">{t("noTeam")}</p> : (
        <section className="card flush">
          <div className="table-wrap">
            <table className="clickable">
              <thead><tr><th>{t("fullName")}</th><th>{t("jobTitle")}</th><th className="hide-sm">{t("department")}</th><th>{t("today")}</th></tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.employment_id} tabIndex={0} onClick={() => onOpen(r.employment_id)} onKeyDown={(e) => { if (e.key === "Enter") onOpen(r.employment_id); }}>
                    <td className="strong">{pick(r.full_name, r.full_name_ar)}</td>
                    <td>{pick(r.job_title ?? "—", r.job_title_ar)}</td>
                    <td className="hide-sm">{r.department_name ? pick(r.department_name, r.department_name_ar) : "—"}</td>
                    <td>
                      <span className={`badge ${tone[r.today]}`}>{t(`att_${r.today}` as StringKey)}</span>
                      {r.check_in && <span className="mono muted"> {r.check_in.slice(0, 5)}</span>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      )}
    </div>
  );
}
